const CREATOR_CLIENTS_KEY = {
  ALL: 'all',
  CLIENT: 'client',
  CREATOR: 'creator',
  CURRENT: 'current',
  DATA: 'data'
}

export { CREATOR_CLIENTS_KEY }
